import { useEffect, useState } from 'react';
import FontSelection from '../screens/fontSelection/FontSelection';
import ContrastSelection from './contrastSelection/ContrastSelection';
import SoundSelection from './soundSelection/SoundSelection';
import MicrophoneSelectionMain from './microphoneSelection/MicrophoneSelectionMain';
import SummaryScreen from './summaryScreen/SummaryScreen';
import { TextIcon, ColourIcon, SoundIcon, MicIcon, VideoIcon } from '../components/styledIcons';
import { Stepper, StepProps, Step } from '../components/Stepper';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { pushFaroEvent, setFaroSession } from '../faroSession';

interface PersonalizationScreenProps {
}

const PersonalizationScreen = (props: PersonalizationScreenProps) => {
    const {
        appFontSize,
        pageObject: { pageIndex },
    } = useSelector((state: RootState) => state.appConfigSlice);
    const [isVideoPlayed, setIsVideoPlayed] = useState<boolean>(false);

    useEffect(() => {
        setFaroSession({ stage: 'precheck' });
        pushFaroEvent('precheck_started');
    }, []);

    let path = [
        {
            sectionName: 'Choose your font size',
            index: 0,
            Component: <FontSelection />,
        },
        {
            sectionName: 'Choose your colour mode',
            index: 1,
            Component: <ContrastSelection />,
        },
        {
            sectionName: 'Check the sound',
            index: 2,
            Component: <SoundSelection />,
        },
        {
            sectionName: 'Choose the microphone',
            index: 3,
            Component: <MicrophoneSelectionMain />,
        },
        {
            sectionName: `Watch the video`,
            index: 4,
            Component: <SummaryScreen isVideoPlayed={isVideoPlayed} setIsVideoPlayed={setIsVideoPlayed} />,
        },
    ];

    let currentComponent = path[pageIndex];

    const getSteps = (): StepProps[] => {
        return [
            { label: '1. Choose text size', icon: <TextIcon /> },
            { label: '2. Choose colour', icon: <ColourIcon /> },
            { label: '3. Check sound', icon: <SoundIcon /> },
            { label: '4. Check microphone', icon: <MicIcon /> },
            { label: '5. Watch video', icon: <VideoIcon /> },
        ];
    };

    const getStepperWidth = () => {
        // values in rem units
        switch (appFontSize) {
            case 'sm':
                return 100;
            case 'md':
                return 110;
            case 'lg':
                return 120;
        }
    };

    return (
        <>
            <Stepper currentActive={currentComponent.index} width={getStepperWidth()}>
                {getSteps().map((step: StepProps, index) => {
                    return <Step {...step} key={'step' + index} />;
                })}
            </Stepper>
            {currentComponent.Component}
        </>
    );
};

export default PersonalizationScreen;
